import styled from 'styled-components';

import { inputBaseCss } from 'components/input/styles';

export const Input = styled.input<{ error?: string }>`
  ${inputBaseCss};
`;

// One small grey line under the box: no button, nothing to click.
export const Hint = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.config.input.placeholder};
`;
